module.exports = __webpack_public_path__ + "static/media/logout.f0014088.png";